import { render, staticRenderFns } from "./EntregasTabela.vue?vue&type=template&id=8ee649b2"
import script from "./EntregasTabela.vue?vue&type=script&lang=js"
export * from "./EntregasTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports